"use client";
import { use, useState } from "react";
import Image from "next/image";
import IconCheckWhite from "@/components/Icon/IconCheckWhite.svg";
import IconHand from "@/components/Icon/IconHand.svg";
import Link from "next/link";
import PartsFinderDialog from "@/components/PartsFinderDialog";
import classNames from "classnames";

export default function VehicleFitmentCheck({ vehicleNumber, bbaProductPromise, vehiclePromise }) {
  const bbaProduct = use(bbaProductPromise);
  const fitList = bbaProduct?.vehicles || [];
  const fitIds = fitList.map(item => item.vehicleNumber);
  const vehicle = use(vehiclePromise);

  const [showPartsFinderDialog, setShowPartsFinderDialog] = useState(false);

  const PositiveVehicle = () => {
    return (
      <div className="flex border-[2px] border-green rounded">
        <div className="min-w-[66px] h-auto flex justify-center items-center bg-green">
          <Image src={IconCheckWhite.src} alt="check" width={46} height={46} className="w-[46px] h-[46px] text-white" />
        </div>
        <div className="w-full p-4">
          <p className="text-sm">This product fits your:</p>
          <p className="font-bold text-lg ">
            {vehicle.make} {vehicle.model} {vehicle.year}
          </p>
          <button className="text-[13px] font-bold text-green" onClick={() => setShowPartsFinderDialog(true)}>
            Change bike selection
          </button>
        </div>
      </div>
    );
  };

  const NegativeVehicle = () => {
    return (
      <div className="flex border-[2px] border-red rounded">
        <div className="min-w-[66px] h-auto flex justify-center items-center bg-red">
          <Image src={IconHand.src} width="26" height="32" alt="hand" />
        </div>
        <div className="w-full p-4">
          <p className="text-sm">Sorry, this product does not fit your:</p>
          <p className="font-bold text-lg ">
            {vehicle.make} {vehicle.model} {vehicle.year}
          </p>
          <Link href={`/accessories?vehicle_ids=${vehicleNumber}`}>
            <button className="w-full rounded-sm font-bold text-white bg-red mt-2 py-1">
              View parts for your bike fitment
            </button>
          </Link>
          <button className="text-[13px] font-bold text-red mt-2" onClick={() => setShowPartsFinderDialog(true)}>
            Change bike selection
          </button>
        </div>
      </div>
    );
  };

  const NoPresentVehicle = () => {
    return (
      <div className="flex border-[2px] border-orange rounded">
        <div className="min-w-[66px] h-auto flex justify-center items-center bg-orange">
          <Image src={IconHand.src} width="26" height="32" alt="hand" />
        </div>
        <div className="w-full p-4">
          <p className="font-bold text-base ">This product is vehicle specific</p>
          <p className="text-sm">Select your bike to ensure fitment</p>
          <button
            className="w-full rounded-sm font-bold text-white bg-orange mt-2 py-1"
            onClick={() => setShowPartsFinderDialog(true)}
          >
            Select your bike
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={classNames("w-full min-h-[124px] rounded bg-white p-2")}>
        <>
          {vehicle && fitIds.includes(vehicle.vehicleNumber) ? (
            <PositiveVehicle />
          ) : vehicleNumber && !fitIds.includes(vehicleNumber) ? (
            <NegativeVehicle />
          ) : (
            <NoPresentVehicle />
          )}
        </>
      </div>

      <PartsFinderDialog
        open={showPartsFinderDialog}
        onOpenDialog={data => setShowPartsFinderDialog(data)}
        vehicle={vehicle}
        redirect={true}
      />
    </>
  );
}
